module.exports = __webpack_public_path__ + "img/Group 24059@2x.1ddd2b82.png";